<template>
    <div>
        <form
            ref="form"
            class="contact-form__input-container"
            @submit.prevent="submit"
        >
            <input type="hidden" name="action" value="contact">
            <div class="contact-form__input-section">
                <label for="first-name" class="access-hidden" v-text="'First Name'"/>
                <input
                    v-model="formFeilds.firstName"
                    name="first-name"
                    id="first-name"
                    type="text"
                    placeholder="First Name"
                    class="contact-form__input contact-form__input_small contact-form__input_small--primary"
                    required
                >
                <label for="last-name" class="access-hidden" v-text="'Last Name'"/>
                <input
                    v-model="formFeilds.lastName"
                    id="last-name"
                    name="last-name"
                    type="text"
                    placeholder="Last Name"
                    class="contact-form__input contact-form__input_small contact-form__input_small contact-form__input_small--secondary"
                    required
                >
            </div>
            <label for="phone-number" class="access-hidden" v-text="'Phone Number'"/>
            <input
                v-model="formFeilds.phoneNumber"
                id="phone-number"
                name="phone-number"
                type="tel"
                class="contact-form__input contact-form__input_big"
                placeholder="Phone Number"
            >
            <label for="email" class="access-hidden" v-text="'Email'"/>
            <input
                v-model="formFeilds.email"
                id="email"
                name="email"
                type="email"
                placeholder="Email Address"
                class="contact-form__input contact-form__input_big"
                required
            >
            <label for="message" class="access-hidden" v-text="'Message'"/>
            <input
                v-model="formFeilds.message"
                id="message"
                name="message"
                type="text"
                class="contact-form__input contact-form__input_big contact-form__input__big-bottom"
                placeholder="Message"
            >
            <div class="contact-form__button-container">
                <p
                    v-if="notValid || submissionError"
                    v-text="options.form_error"
                    class="paragraph-01 contact-form__validity-copy"
                />
                <button
                    v-if="!success"
                    type="submit"
                    :disabled="submitting"
                    aria-pressed="false"
                    aria-describedby="submit-button"
                    class="contact-form__submit-btn"
                >
                    <span class="contact-form__submit-btn-text">{{ options.submit_button_text }}</span>
                </button>
                <div
                    v-if="success"
                    class="contact-form__submitted-container"
                >
                    <h3 class="paragraph-01" v-text="options.form_submit"/>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'contact-form',
    props: {
        options: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            success: null,
            notValid: null,
            submitting: false,
            submissionError: false,
            formFeilds: {
                email: undefined,
                message: undefined,
                lastName: undefined,
                firstName: undefined,
                phoneNumber: undefined,
            },
        };
    },
    methods: {
        async submit() {
            if (this.submitting) {
                return;
            }

            // HTML5 validity check
            if (!this.$refs.form.checkValidity()) {
                this.notValid = true;
                return;
            }

            this.notValid = false;
            this.submissionError = false;
            this.submitting = true;

            try {
                // 1) Get reCAPTCHA token
                const token = await this.getRecaptchaToken();

                // Add the token directly to the outgoing request.
                const formData = new FormData(this.$refs.form);
                formData.set('g-recaptcha-response', token);

                const response = await axios.post('/wp-admin/admin-ajax.php', formData);

                if (!response.data || response.data.success !== true) {
                    throw new Error('Form submission failed');
                }

                this.resetForm('success', 'notValid');
            } catch (e) {
                this.success = false;
                this.submissionError = true;
            } finally {
                this.submitting = false;
            }
        },

        getRecaptchaToken() {
            return new Promise((resolve, reject) => {
                if (typeof window.grecaptcha === 'undefined') {
                    reject(new Error('reCAPTCHA not loaded'));
                    return;
                }

                window.grecaptcha.ready(() => {
                    window.grecaptcha.execute('6Ld0sicsAAAAAIssHD-NHTWp6dkwKMH_CybkoPSC', { action: 'contact' })
                        .then(token => resolve(token))
                        .catch(err => reject(err));
                });
            });
        },

        resetForm(successful, unsuccessful) {
            this[successful] = true;
            this[unsuccessful] = false;

            if (this[successful]) {
                Object.keys(this.formFeilds).forEach((key) => {
                    this.formFeilds[key] = '';
                });
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// ContactForm.vue?75a66bff